import { render, staticRenderFns } from "./AddressAutocomplete.vue?vue&type=template&id=2118f24e&scoped=true"
import script from "./AddressAutocomplete.vue?vue&type=script&lang=js"
export * from "./AddressAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./AddressAutocomplete.vue?vue&type=style&index=0&id=2118f24e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2118f24e",
  null
  
)

export default component.exports